/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "accounts",
            "endpoint": "https://xeei9jujkl.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "hotels",
            "endpoint": "https://xk9ii49idh.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:7434a5d6-b704-4c0b-b10c-386bae9131c9",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ntMGN2YEA",
    "aws_user_pools_web_client_id": "6llqjghbqqt1m7i21p171m7ic4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "cc-account-distribution-configs-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "cc-account-distribution-hotels-prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
